<div class="team-photos">
    @if (team.player1.id) {
        <app-player-photo [player]="team.player1" class="player-one"></app-player-photo>
    }
    @if (team.player2?.id) {
        <app-player-photo [player]="team.player2" class="player-two"></app-player-photo>
    }
</div>

<div class="team-seed">
    {{ teamSuffixSeed }}
</div>

<div class="team-names">
    @if (team.player1) {
        <span [class]="{ loser: !team.is_winner, setwin: team.is_winner }"> {{ [team.player1.first_name, team.player1.last_name, 'TBD'] | shortName }} </span>
    }

    @if (team.player2 && team.player2.id) {
        <span [class]="{ loser: !team.is_winner, setwin: team.is_winner }">
            {{ [team.player2.first_name, team.player2.last_name, 'TBD'] | shortName }}
        </span>
    }
</div>

<div class="player-status">
    @if (checkStatus()) {
        <mat-icon class="serve flex center"> fiber_manual_record </mat-icon>
    }
    @if (checkStatus(true)) {
        <mat-icon class="winner flex center"> done</mat-icon>
    }
</div>

@if (match_status || faceoff_scores) {
    <div class="scores" [class]="{ loser: !team.is_winner }">
        @for (set of team.sets; track $index) {
            <div class="game-score" [class]="[set?.games || 0 > opponent_set[$index].games ? 'winner_set' : 'loser_set']">
                {{ set?.games || 0 }}
                @if (set.tiebreak !== 0) {
                    <sup>{{ set.tiebreak }}</sup>
                }
            </div>
        }
        @if (checkMatchStatusForPointDisplay) {
            <div class="team-points">
                {{ team.points || 0 }}
            </div>
        }
    </div>
}
